import { makeStyles } from '@material-ui/styles';

const styles = () => ({
    page: {
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
    },
});

export default styles;
export const useStyles = makeStyles(styles);
